/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubPrompt/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function SubPrompt({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Content/Editor/Content/EditArea/QuestionFields/Content/SubPrompt",
  isInvalid,
  onChange
  
}) {
let questionSubpromptValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'subprompt',
})
let questionSubpromptIsValidData = fromData.useDataIsValid({ viewPath,
context: 'question',
path: 'subprompt',
validate: fromValidate.textInput,
})
let questionSubpromptChangeData = fromData.useDataChange({ viewPath,
context: 'question',
path: 'subprompt',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginRight={dtSpaceXs}
 maxWidth={562}
 data="question.subprompt"
 validate="/Data/validate.js textInput"
 required={false}
 value={questionSubpromptValueData}
 invalid={!questionSubpromptIsValidData}
 onChange={questionSubpromptChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Further Prompt Detail"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}